import React, { useEffect, useState, memo } from "react";
import { useFavorite } from "modules/Favorites/hooks";
import { useAuthModal } from "core/context";
import Icon from "core/assets/icons";

export type IProps = {
  active?: boolean,
  id: number,
  countFollow?: number,
  onChange?: (id: number, state: boolean) => void,
  className?: string;
  reload?: (cb: any) => void;
  viewOnly?: boolean;
};

const CFollowComunity = ({
  id,
  onChange,
  active = false,
  className,
  reload,
  countFollow = 0,
  viewOnly = false,
}: IProps) => {
  const { openModal, token } = useAuthModal();
  const { handleFavorite } = useFavorite()
  const [ stateActive, setStateActive ] = useState<boolean>(active);
  const [ countHeart, setCountHeart ] = useState<number>(countFollow);



  useEffect(() => {
    setStateActive(active)
  }, [active, id])

  useEffect(() => {
    setCountHeart(countFollow)
  }, [countFollow])

  const toggleFavorite = () => {
    if(viewOnly){
      return
    }
    onChange?.(id, !stateActive)
    if(id == 0){
      handleFavorite({
        id: String(id),
        stateActive: !stateActive,
      })
    }
    let countData = countHeart
    if(!stateActive){
      countData = countData + 1
      setCountHeart(countData)
    }else {
      countData = countData - 1
      setCountHeart(countData > 0 ? countData : 0)
    }
    setStateActive((p: boolean) => !p)
  }

  const _handleClickNote = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (!token) {
      openModal(() => {
        reload?.((newState: boolean) => {
          if (!newState) {
            document.getElementById(`NoteItem-${id}`)?.click()
          }
        })
      });
      return;
    }

    toggleFavorite();
  };

  return (
    <>
      <span
          className={`flex items-center ${className}`}
          onClick={_handleClickNote}
          id={`NoteItem-${id}`}
        >
          <img className="mr-[5px]" src={Icon.UserFollow} alt={'UserFollow'} />
          <label className={`text-[11px] text-[#333333]`}>
            {countHeart}
          </label>
        </span>
    </>
  );
};


export default memo(CFollowComunity);
